export default "__VITE_ASSET__CrZOLq_2__"